import React from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import reqwest from 'reqwest';
import {
  faPlus,
  faGripLinesVertical,
  faSave,
  faTrashAlt,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { v4 as uuid } from 'uuid';
import swal from 'sweetalert';
import settings from '../../../../../settings';
import Loader from '../../../../components/Loader';
import Button from '../../../../components/Button';
import ContentBox from '../../../../components/FormArea/ContentBox';
import { invalidateConstants } from '../../../../logic/constants';

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

class ConstantsDetail extends React.Component {
  constructor(props) {
    super(props);

    this.type = props.match.params.key;
    this.parentRoute = this.props.match.url.replace(
      new RegExp(`/${this.type}$`),
      '',
    );

    reqwest({
      method: 'GET',
      url: settings.constants.getList,
      data: {
        Token: localStorage.getItem('token'),
        Typ: this.type,
      },
    }).then((constant) => {
      constant = JSON.parse(constant);

      const fields = [...this.state.fields];
      if (constant[0]?.Title) {
        fields.push({
          label: constant[0].Title,
          value: 'ExtraField',
        });
      }

      constant = constant
        .filter((con) => {
          return con.Guid;
        })
        .sort((a, b) => {
          return parseInt(a.Ord) - parseInt(b.Ord);
        });

      this.setState({
        loading: false,
        constant,
        fields,
      });
    });

    this.state = {
      loading: true,
      hasChanges: false,
      constant: [],
      fields: [
        {
          label: 'Name',
          value: 'Name',
        },
        {
          label: 'Kurzkennzeichen (KKZ)',
          value: 'KKZ',
        },
      ],
    };
  }

  save = () => {
    // Namen muessen innerhalb eines Typs eindeutig bleiben - sonst sind die
    // Eintraege in den Dropdowns nicht mehr unterscheidbar.
    const names = this.state.constant.map((entry) => {
      return (entry.Name || '').trim().toLowerCase();
    });
    const duplicate = names.find((name, index) => {
      return name && names.indexOf(name) !== index;
    });
    if (duplicate) {
      swal({
        title: 'Doppelter Name',
        text: `Der Name "${duplicate}" ist mehrfach vergeben. Bitte eindeutige Namen verwenden.`,
        icon: 'error',
      });
      return;
    }

    this.setState({
      loading: true,
    });
    const savePromises = [];
    [...this.state.constant].forEach((constant, index) => {
      constant.Ord = index;
      if (constant.Changed === true) {
        delete constant.Changed;
        if (constant.Guid.startsWith('new:')) {
          constant.Guid = '';
        }
        savePromises.push(
          reqwest({
            method: 'POST',
            url: settings.constants.save,
            data: {
              Token: localStorage.getItem('token'),
              Constant: JSON.stringify(constant),
            },
          }).then((saveResult) => {
            saveResult = JSON.parse(saveResult);
            return saveResult.SaveResult;
          }),
        );
      }
    });

    if (savePromises.length === 0) {
      swal({
        title: 'Keine Änderungen...',
        text: 'Die Konstanten wurden nicht geändert oder sind unvollständig.',
        icon: 'warning',
      });
    }

    Promise.all(savePromises)
      .then((saveResults) => {
        if (!saveResults.length) {
          this.setState({ loading: false });
          return;
        }
        // Vorher: `result !== 'Updated' || result !== 'Saved'` - das ist immer wahr,
        // dadurch wurde auch bei fehlgeschlagenem Speichern "Erfolgreich" gemeldet.
        const failed = saveResults.filter((result) => {
          return result !== 'Updated' && result !== 'Saved';
        });
        if (failed.length) {
          swal({
            title: 'Speichern fehlgeschlagen',
            text: `${failed.length} von ${saveResults.length} Einträgen konnten nicht gespeichert werden: ${failed.join(', ')}`,
            icon: 'error',
          });
          this.setState({ loading: false });
          return;
        }
        // Cache leeren, sonst zeigen offene Formulare weiter die alten Bezeichnungen.
        invalidateConstants(this.type);
        swal({
          title: 'Erfolgreich!',
          text: 'Die Konstante wurde erfolgreich gespeichert.',
          icon: 'success',
        });
        this.setState({ hasChanges: false, loading: false });
      })
      .catch(() => {
        swal({
          title: 'Speichern fehlgeschlagen',
          text: 'Beim Speichern ist ein Fehler aufgetreten.',
          icon: 'error',
        });
        this.setState({ loading: false });
      });
  };

  delete = (entry) => {
    swal({
      title: 'Sind Sie sich sicher?',
      text: `Möchten Sie die Konstante "${entry.Name}" wirklich löschen? Dies kann nicht Rückgängig gemacht werden!\nAlle Datensätze welche "${this.props.match.params.value}" verwenden könnten beschädigt werden.`,
      icon: 'warning',
      buttons: ['Abbrechen', 'Löschen'],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        if (!entry.Guid.startsWith('new:')) {
          reqwest({
            method: 'GET',
            url: settings.constants.delete,
            data: {
              Token: localStorage.getItem('token'),
              Guid: entry.Guid,
            },
          }).then((deleteResult) => {
            deleteResult = JSON.parse(deleteResult);

            if (deleteResult.DeleteResult === 'Deleted') {
              // Cache leeren, sonst zeigen offene Formulare die Konstante weiter an.
              invalidateConstants(this.type);
              swal({
                title: 'Erfolgreich!',
                text: `Die Konstante "${entry.Name}" wurde erfolgreich gelöscht.`,
                icon: 'success',
              });

              const constant = [...this.state.constant].filter((con) => {
                return con.Guid !== entry.Guid;
              });
              this.setState({
                constant,
              });
              return;
            }

            // Ein abgelehntes Loeschen war bisher komplett stumm. Jetzt wird der
            // Grund angezeigt - insbesondere wenn die Konstante noch benutzt wird.
            if (deleteResult.Reason === 'InUse') {
              const usedIn = (deleteResult.UsedIn || []).join(', ');
              swal({
                title: 'Löschen nicht möglich',
                text:
                  `Die Konstante "${entry.Name}" wird noch von ${deleteResult.UsageCount} Datensatz/Datensätzen verwendet` +
                  (usedIn ? ` (${usedIn}).` : '.') +
                  '\nBitte zuerst die Verweise ändern.',
                icon: 'warning',
              });
              return;
            }

            if (deleteResult.Reason === 'CheckFailed') {
              swal({
                title: 'Löschen nicht möglich',
                text: `Es konnte nicht vollständig geprüft werden, ob "${entry.Name}" noch verwendet wird. Zur Sicherheit wurde nicht gelöscht. Bitte später erneut versuchen.`,
                icon: 'error',
              });
              return;
            }

            swal({
              title: 'Löschen nicht möglich',
              text: `Die Konstante "${entry.Name}" konnte nicht gelöscht werden.`,
              icon: 'error',
            });
          });
        } else {
          const constant = [...this.state.constant].filter((con) => {
            return con.Guid !== entry.Guid;
          });
          this.setState({
            constant,
          });
        }
      }
    });
  };

  onDragEnd = (result) => {
    if (!result.destination) return;

    let items = reorder(
      this.state.constant,
      result.source.index,
      result.destination.index,
    );
    items = items.map((item, index) => {
      item.Ord = index;
      item.Changed = true;
      return item;
    });

    this.setState({
      constant: items,
      hasChanges: true,
    });
  };

  addConstant = () => {
    const { constant } = this.state;

    let newConstant = {
      Guid: `new:${uuid()}`,
      Typ: this.type,
      Name: '',
      KKZ: '',
      Ord: '',
    };

    if (constant[0]?.Title) {
      newConstant = {
        ...newConstant,
        Title: constant[0].Title,
        FieldType: constant[0].FieldType,
        ExtraField: '',
      };
    }

    this.setState({
      constant: [...constant, newConstant],
      hasChanges: true,
    });
  };

  render() {
    if (this.state.loading) {
      return <Loader />;
    }

    const maxWidth = `calc((100% - 80px) / ${this.state.fields.length})`;
    const minWidth = `calc((100% - 80px) / ${this.state.fields.length})`;

    return (
      <>
        <div className="Page-Content">
          <div className="Buttonbar">
            {this.state.hasChanges && (
              <Button type="primary" icon={faSave} onClick={this.save}>
                Speichern
              </Button>
            )}
            <Button icon={faPlus} onClick={this.addConstant}>
              Konstanten hinzufügen
            </Button>
          </div>
          <ContentBox title={this.props.match.params.value}>
            <div className="Table">
              <div className="Table-head">
                <div
                  className="Table-head-field"
                  style={{
                    maxWidth: '61px',
                    minWidth: '61px',
                  }}
                >
                  {' '}
                </div>
                {this.state.fields.map((field) => {
                  return (
                    <div
                      key={field.value}
                      className="Table-head-field"
                      style={{ maxWidth, minWidth }}
                    >
                      {field.label}
                    </div>
                  );
                })}
                <div
                  className="Table-head-field"
                  style={{
                    maxWidth: '40px',
                    minWidth: '40px',
                  }}
                >
                  {' '}
                </div>
              </div>
              <div className="Table-body">
                <DragDropContext onDragEnd={this.onDragEnd}>
                  <Droppable droppableId="Table-body">
                    {(provided) => {
                      return (
                        <div
                          {...provided.droppableProps}
                          ref={provided.innerRef}
                        >
                          {this.state.constant.map((constant, cIndex) => {
                            return (
                              <Draggable
                                key={constant.Guid}
                                draggableId={constant.Guid}
                                index={cIndex}
                              >
                                {(provided) => {
                                  return (
                                    <div
                                      className="Table-body-row"
                                      ref={provided.innerRef}
                                      {...provided.draggableProps}
                                      {...provided.dragHandleProps}
                                    >
                                      <div
                                        className="Table-body-data"
                                        style={{
                                          maxWidth: '40px',
                                          minWidth: '40px',
                                        }}
                                      >
                                        <FontAwesomeIcon
                                          className="Table-body-data-icon"
                                          icon={faGripLinesVertical}
                                        />
                                      </div>
                                      {this.state.fields.map((field) => {
                                        // Das KKZ bestehender Eintraege ist gesperrt:
                                        // Programmlogik vergleicht auf KKZ-Literale
                                        // (z.B. "stattgefunden", "MI", "PFV") - eine
                                        // Aenderung wuerde diese Logik brechen. Der
                                        // Name bleibt frei umbenennbar.
                                        const isKkzLocked =
                                          field.value === 'KKZ' &&
                                          !String(
                                            constant.Guid || '',
                                          ).startsWith('new:');
                                        return (
                                          <div
                                            key={field.value}
                                            className="Table-body-data"
                                            style={{ maxWidth, minWidth }}
                                          >
                                            <input
                                              type="text"
                                              className="Table-body-data-value"
                                              defaultValue={
                                                constant[field.value]
                                              }
                                              readOnly={isKkzLocked}
                                              title={
                                                isKkzLocked
                                                  ? 'Das Kurzkennzeichen (KKZ) kann nachträglich nicht geändert werden, da Programmlogik darauf aufbaut.'
                                                  : undefined
                                              }
                                              onChange={(event) => {
                                                event.persist();
                                                const constant = [
                                                  ...this.state.constant,
                                                ];
                                                constant[cIndex][field.value] =
                                                  event.target.value;
                                                constant[cIndex].Changed = true;

                                                // hasChanges steuert die Anzeige des
                                                // Speichern-Buttons. Ohne dieses Flag blieb
                                                // der Button beim Bearbeiten eines Feldes
                                                // unsichtbar - Umbenennen war dadurch nicht
                                                // speicherbar.
                                                this.setState({
                                                  constant,
                                                  hasChanges: true,
                                                });
                                              }}
                                            />
                                          </div>
                                        );
                                      })}
                                      <div
                                        className="Table-body-data"
                                        style={{
                                          maxWidth: '40px',
                                          minWidth: '40px',
                                        }}
                                      >
                                        <FontAwesomeIcon
                                          className="Table-body-data-icon"
                                          icon={faTrashAlt}
                                          onClick={() => {
                                            this.delete(constant);
                                          }}
                                        />
                                      </div>
                                    </div>
                                  );
                                }}
                              </Draggable>
                            );
                          })}
                          {provided.placeholder}
                        </div>
                      );
                    }}
                  </Droppable>
                </DragDropContext>
              </div>
            </div>
          </ContentBox>
        </div>
      </>
    );
  }
}

export default ConstantsDetail;
